import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingSpinner = () => (
  <div>
    <CircularProgress className="progress" />
  </div>
);

export default LoadingSpinner;